(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nos-hover-links"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nos-hover-links')) {
    customElements.define(
      'nos-hover-links',
      class NosHoverLinks extends HTMLElement {
        connectedCallback() {
          this.abortController = new AbortController();
          this.links = [...this.querySelectorAll('[data-nos-hover-link]')];
          this.previews = new Map(
            [...this.querySelectorAll('[data-nos-hover-preview]')].map((preview) => [
              preview.dataset.nosHoverPreview,
              preview,
            ])
          );

          this.links.forEach((link) => {
            link.addEventListener('pointerenter', (event) => this.activate(link, event), {
              signal: this.abortController.signal,
            });
            link.addEventListener('focus', () => this.activateFromKeyboard(link), {
              signal: this.abortController.signal,
            });
            link.addEventListener('blur', () => this.deactivate(), {
              signal: this.abortController.signal,
            });
          });

          this.addEventListener('pointermove', (event) => this.positionPreview(event.clientX, event.clientY), {
            signal: this.abortController.signal,
          });
          this.addEventListener('pointerleave', () => this.deactivate(), {
            signal: this.abortController.signal,
          });
        }

        disconnectedCallback() {
          this.abortController?.abort();
        }

        activate(link, event) {
          if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
          this.setActivePreview(link.dataset.nosHoverLink);
          this.positionPreview(event.clientX, event.clientY);
        }

        activateFromKeyboard(link) {
          if (!window.matchMedia('(min-width: 750px)').matches) return;
          this.setActivePreview(link.dataset.nosHoverLink);
          const bounds = link.getBoundingClientRect();
          this.positionPreview(bounds.left + bounds.width / 2, bounds.top + bounds.height / 2);
        }

        setActivePreview(id) {
          this.activePreview?.removeAttribute('data-active');
          this.activePreview = this.previews.get(id);
          this.activePreview?.setAttribute('data-active', 'true');
        }

        positionPreview(pointerX, pointerY) {
          if (!this.activePreview) return;
          const bounds = this.activePreview.getBoundingClientRect();
          const gap = 28;
          const edge = 16;
          let left = pointerX + gap;
          let top = pointerY - bounds.height / 2;

          if (left + bounds.width > window.innerWidth - edge) {
            left = pointerX - bounds.width - gap;
          }

          top = Math.max(edge, Math.min(top, window.innerHeight - bounds.height - edge));
          this.activePreview.style.setProperty('--nos-preview-x', `${Math.round(left)}px`);
          this.activePreview.style.setProperty('--nos-preview-y', `${Math.round(top)}px`);
        }

        deactivate() {
          this.activePreview?.removeAttribute('data-active');
          this.activePreview = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
